<template>
  <DetailsAccordion
    :error-description="i18n(translations.errorDescription)"
    :status
    @refresh="refresh"
  >
    <template #icon>
      <IconLocationPinOutlined />
    </template>
    <template #title>
      {{ i18n(translations.title) }}
    </template>
    <template #description>
      <span data-test="description">
        <span v-if="!mostRecentProductReturn">
          {{ i18n(translations.noProductReturnDescription) }}
        </span>
        <span v-else data-allow-mismatch="text">
          <template
            v-if="
              !mostRecentProductReturn.datePickedUp &&
              !mostRecentProductReturn.dateDelivered &&
              mostRecentProductReturn.creationDate
            "
          >
            {{
              i18n(translations.creationDate, {
                date: new Date(mostRecentProductReturn.creationDate),
              })
            }}
          </template>

          <PickedUpDate
            v-if="
              mostRecentProductReturn.datePickedUp &&
              !mostRecentProductReturn.dateDelivered
            "
            :date="mostRecentProductReturn.datePickedUp"
            :is-one-way="isOneWay(mostRecentProductReturn)"
          />

          <DeliveredDate
            v-if="mostRecentProductReturn.dateDelivered"
            :date="mostRecentProductReturn.dateDelivered"
            :is-one-way="isOneWay(mostRecentProductReturn)"
          />
        </span>
      </span>
    </template>
    <template #body>
      <p v-if="isEmpty(productReturns)">
        {{ i18n(translations.noProductReturnText) }}
      </p>
      <div v-else class="space-y-16">
        <ul class="space-y-16" data-test="product-returns">
          <li
            v-for="productReturn in productReturns"
            :key="productReturn.shipmentPublicId"
          >
            <ProductReturn :product-return />
          </li>
        </ul>

        <div v-if="lastOneWayProductReturn && lastOneWayProductReturn.shipment">
          <p class="body-2-bold">
            {{
              i18n(translations.customerAddressTitle, {
                date: new Date(lastOneWayProductReturn.creationDate),
              })
            }}
          </p>
          <Address
            v-if="lastOneWayProductReturn.shipment.dispatchAddress"
            :address="lastOneWayProductReturn.shipment.dispatchAddress"
          />
        </div>
      </div>
    </template>
  </DetailsAccordion>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { IconLocationPinOutlined } from '@ds/icons/IconLocationPinOutlined'

import { useOrderlineDetails } from '~/scopes/customer-care/pages/request/composables/useOrderlineDetails'

import Address from '../Address.vue'
import DetailsAccordion from '../DetailsAccordion/DetailsAccordion.vue'

import DeliveredDate from './ProductReturn/DeliveredDate.vue'
import PickedUpDate from './ProductReturn/PickedUpDate.vue'
import { isOneWay } from './ProductReturn/ProductReturn.utils'
import ProductReturn from './ProductReturn/ProductReturn.vue'
import translations from './Returns.translations'

const i18n = useI18n()

const {
  returnsDetails: { data, status, refresh },
} = useOrderlineDetails()

const { mostRecentProductReturn, productReturns } = data

const lastOneWayProductReturn = computed(() => {
  const oneWayProductReturns = productReturns?.value?.filter(
    (productReturn) => {
      return isOneWay(productReturn)
    },
  )

  if (!oneWayProductReturns) {
    return null
  }

  return oneWayProductReturns[oneWayProductReturns.length - 1]
})
</script>
